module.exports = __webpack_public_path__ + "img/parter-work7.af92276d.png";